import React, { useState, useEffect } from 'react'
import { Bracks, currentWeekPrev, weekNumbers } from '../../api/routes';
import ReceptChooseDialog from '../recept/ReceptChooseDialog';
import './styles.css'
import FormWrapper from '../components/FormWrapper/FormWrapper';

import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect'
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';

const weekDays = ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag', 'Välj Dag']


export default function CreateBrackDialog(props) {
  const [open, setOpen] = useState(false);
  const [newBrack, setNewBrack] = useState(true)

  const weeks = weekNumbers()

  const genBrack = () => {
    const {order} = props
    const _brack = {
      smak: order.smak, subSmak: "", sort: order.sort, batch: 0,
      dag: "Okej", kommentar: "", orderID: order.id, done: false, toFrys: false,
      type: order.type, prio: 1, subSmaker: order.subSmaker, week: currentWeekPrev(), year: new Date().getFullYear(),
    }
    return _brack
  }

  const [brack, setBrack] = useState(genBrack())

  useEffect(() => {
    checkIfExist()
  }, [])
  useEffect(() => {
    checkIfExist()
  }, [props.renderButtons])


  useEffect(() => {
    setBrack(genBrack())
  }, [props.order])

  const handleClickOpen = async () => {
    if (props.isAdmin()) {
      checkIfExist()
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleUpdate = (name, value) => {
    const _brack = { ...brack }
    _brack[name] = value
    setBrack(_brack)
  }
  const handleUpdateDay = e => {
    const _brack = { ...brack }
    if(_brack.day_index !== 7) {
    _brack.day_index = e.target.value
    _brack.dag = weekDays[e.target.value]
    } else {
      _brack.day_index = 0
      _brack.dag = weekDays[0]
    }
    setBrack(_brack)
  }
  const handleUpdateArray = (arr) => {
    const _brack = { ...brack }
    arr.map(item => _brack[item.name] = item.value)
    setBrack(_brack)
  }
  const handleUpdateEvent = e => {
    const { name, value } = e.target
    const _brack = { ...brack }
    _brack[name] = value
    setBrack(_brack)
  }

  const handleDelete = async () => {
    if (window.confirm('Är du säker att du vill radera denna order?')) {
      setNewBrack(true)
      handleClose()
      handleUpdate('dag', 'Okej')
      await Bracks.Delete(brack)
      await props.getData()
    };
  }

  const handleCreate = async () => {
    const _brack = { ...brack }
    _brack.dag = weekDays[_brack.day_index]

    handleClose()
    if (newBrack) await Bracks.Create(_brack)
    else await Bracks.Update(_brack)
    // await props.getData()
  }

  const checkIfExist = async () => {
    const arr = await Bracks.ReadByOrderID(props.order.id)
    if (arr.length > 0) {
      // filtrerar ut rätt vecka och ej färdigställda samt sorterar på dag
      const _arr = arr.filter(item => item.week == currentWeekPrev() && !item.done)
      _arr.sort(function(a, b) { return a.day_index - b.day_index })

      const latest = _arr[0]
      // setCook(latest)
      // setNewCook(false)
      if(latest) {
        const _brack = {...brack}
        _brack.dag = latest.dag
        setBrack(_brack)
      }
    }
  }

  const isBland = props.order.type == 'Bland'

  const buttonStyle = brack.dag == 'Okej' ? '#04a466' : '#2980b9'

  const underSmakSelect = <FormControl variant="standard">
    <InputLabel id="demo-simple-select-label">Undersmak</InputLabel>
    <NativeSelect
      value={brack.subSmak}
      name="subSmak"
      onChange={handleUpdateEvent}
      inputProps={{ name: 'subSmak', id: 'uncontrolled-native', }}
    >{props.order.subSmaker.filter(item => item !== '').map(item => <option key={item} value={item}>{item}</option>)}
    </NativeSelect>
  </FormControl>

  return (
    <div>
      <FormWrapper label="Bräck">
        <div className="CreateCookDialog__button" onClick={handleClickOpen} style={{ backgroundColor: buttonStyle }}>{brack.dag}</div>
      </FormWrapper>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Planera en bräck</DialogTitle>
        <DialogContent className="CreateOrderDialog__form">
          <div className="flex">
            <TextField
              id="standard-basic" label="Smak" variant="standard"
              onChange={handleUpdateEvent}
              value={brack.smak}
              name="smak"
              InputProps={{ readOnly: true, }}
            />
            {isBland && <div className="spacer-5" />}
            {isBland && underSmakSelect}

            <div className="spacer-5" />
            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Typ</InputLabel>
              <NativeSelect
                value={brack.sort}
                name="sort"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'sort', id: 'uncontrolled-native', }}
              >{['Sort', 'Tryffel', 'Nougat', 'Kola', 'Flera'].map(item => <option key={item} value={item}>{item}</option>)}
              </NativeSelect>
            </FormControl>

            <div className="spacer-5" />
            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Batch</InputLabel>
              <NativeSelect
                value={brack.batch}
                name="batch"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'batch', id: 'uncontrolled-native', }}
              >{[...Array(7).keys()].map(item => <option key={item} value={item}>{item}</option>)}
              </NativeSelect>
            </FormControl>

            <div className="spacer-5" />
            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Planerad Dag</InputLabel>
              <NativeSelect
                value={brack.day_index}
                name="day_index"
                onChange={handleUpdateDay}
                inputProps={{ name: 'day_index', id: 'uncontrolled-native', }}
              >{[7, 0, 1, 2, 3, 4, 5, 6].map(item => <option key={item} value={item}>{weekDays[item]}</option>)}
              </NativeSelect>
            </FormControl>
            <div className="spacer-5" />

            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Vecka</InputLabel>
              <NativeSelect
                value={brack.week}
                name="week"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'week', id: 'uncontrolled-native', }}
              >{weeks.map(item => <option key={item} value={item}>{item}</option>)}
              </NativeSelect>
            </FormControl>

            <div className="spacer-5" />

            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">År</InputLabel>
              <NativeSelect
                value={brack.year}
                name="year"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'year', id: 'uncontrolled-native', }}
              >{['2023', '2024', '2025', '2026'].map(item => <option key={item} value={item}>{item}</option>)}
              </NativeSelect>
            </FormControl>
          </div>

          <div className="spacer-5" />

          <div className="flex">
            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-label">Prio</InputLabel>
              <NativeSelect
                value={brack.prio}
                name="prio"
                onChange={handleUpdateEvent}
                inputProps={{ name: 'prio', id: 'uncontrolled-native', }}
              >{[[1, 'Låg'], [2, 'Medel'], [3, 'Hög']].map(item => <option key={item[0]} value={item[0]}>{item[1]}</option>)}
              </NativeSelect>
            </FormControl>
            <div className="spacer-5" />

            {/* <FormWrapper label="Till Frysen">
              <Switch
                checked={cook.toFrys}
                name="toFrys"
                onChange={e => handleUpdate(e.target.name, e.target.checked)}
                inputProps={{ 'aria-label': 'controlled' }}
                color="primary"
              />
            </FormWrapper>
            <div className="spacer-5" /> */}

            <ReceptChooseDialog handleUpdateArray={handleUpdateArray} cook={brack} />
            <div className="spacer-5" />

            <TextField
              id="standard-basic" label="Kommentar" variant="standard"
              onChange={handleUpdateEvent}
              value={brack.kommentar}
              name="kommentar"
              multiline
              maxrows={4}
            />
            <div className="spacer-5" />

          </div>
        </DialogContent>
        <DialogActions className="CreateOrderDialog__buttons">
          <div className="flex-center">
            <Button onClick={handleClose}>Stäng</Button>
            {!newBrack && <Button color="secondary" onClick={handleDelete}>Radera</Button>}
          </div>
          <Button color="primary" onClick={handleCreate}>Spara</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
